import Vue from 'vue'
import App from './App.vue'
import vuetify from './plugins/vuetify'
import "vuetify/dist/vuetify.min.css"
import './plugins/vuetify-extra'
import { TiptapVuetifyPlugin } from "tiptap-vuetify"
import "tiptap-vuetify/dist/main.css"

import router from './plugins/router'

import axios from './lib/axios'

import './plugins/filters'
import './plugins/components'

import store from './store'

//const log = console.log

Vue.config.productionTip = false

Vue.use(TiptapVuetifyPlugin, {
    vuetify,
    iconsGroup: "mdi"
});

new Vue({
  vuetify,
  router,
  render: h => h(App),
  created() {
    if (!store.getters.auth) return
        axios.defaults.headers.common = {
            "Authorization" : "Bearer " + store.getters.auth,
    }
  },
  store
}).$mount('#app')
